import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useLocPurchaseGetOne } from 'core/types'

import ModelLink from './ModelLink'

type PurchaseLinkProps = {
  purchaseId: string
}

const PurchaseLink: FC<PurchaseLinkProps> = ({ purchaseId }) => {
  const [_, { companyId, personId, loanId }] = useQueryApi()
  const { data: purchase, isLoading } = useLocPurchaseGetOne({
    personId,
    loanId,
    purchaseId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  const drawId = purchase?.drawId

  const link =
    companyId &&
    personId &&
    loanId &&
    drawId &&
    `/companies/${companyId}/borrowers/${personId}/loans/${loanId}/draws/${drawId}/purchases/${purchaseId}`

  return (
    <ModelLink
      id={purchaseId}
      isLoading={isLoading}
      link={link}
      model={purchase}
    />
  )
}

export default PurchaseLink
